export default __webpack_public_path__ + "static/media/387.6fb208b9.png";